import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Do you use any special time tracking software?",
  "description": "",
  "published": "2019-02-22T00:00:00.000Z",
  "redirect_from": ["/blog/do-you-use-any-special-time-tracking-software/swizec/8954"],
  "categories": "Personal",
  "hero": "./img/8RoOYk3.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Jonas asks if I use any special time tracking software. A common question in fact. People ask me all the time 🤔`}</p>
    <p>{`Yes, several.`}</p>
    <p>{`I have 2 primary and 2 secondary time trackers these days. Used to experiment with a lot of different tools and according to The Good Shit Stays principle, this is what stuck.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://getklok.com/"
        }}>{`Klok`}</a>{` for areas of time`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://toggl.com/"
        }}>{`Toggl`}</a>{` for billable hours`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.rescuetime.com/"
        }}>{`RescueTime`}</a>{` for focus tracking`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://timeular.com/"
        }}>{`Timeular`}</a>{` for sidehustle areas of time`}</li>
    </ul>
    <h2 {...{
      "id": "areas-of-time--klok"
    }}>{`Areas of time – Klok`}</h2>
    <p>{`You're familiar with calendars. They specify your agenda, your plan for the week. If you color code events you can take one look and see how much time you spend in meetings, at the gym, studying, or whatever.`}</p>
    <p>{`Here's my calendar`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/f3015/8RoOYk3.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.15695067264574%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'220\\'%20viewBox=\\'0%200%20400%20220\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M29%2012c0%204%202%205%202%201%201-3%203-4%203%200%201%203%207%204%207%201v-2l1%202%204%202c3%200%203-1%203-4%200-4%200-4-3-4-2%200-3%200-3%202%200%201%200%202-1%201l-1-2-1-1-1%202-1%204-1-3c0-3%200-3-4-3h-4v4m243%2010c-3%202-4%203-4%206%200%205%208%207%2010%203%203-3%202-5%200-8-3-2-4-2-6-1m-79%20136c0%203%200%203%203%203h6l6-1h11l2%201c2%201%204%200%204-2s0-2-8-2a194%20194%200%2001-21%200c-3-1-3-1-3%201M35%20175c-2%201-1%204%202%204h5l14-1h2c2%203%204%202%204%200l-2-2-1-1H35m159%200c-2%202-1%204%203%204l19-1h1c1%202%204%202%205%200%200-1-2-3-3-2l-1-1h-24m53%200l-1%202c0%202%203%203%2010%202h7l6-1h2c2%202%204%202%204-1l-2-1-2-1h-24\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/159cb41a1b6d61b5fa6a72688b9ba0bd/ca0a1/8RoOYk3.webp 223w", "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/75680/8RoOYk3.webp 445w", "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/8d1ba/8RoOYk3.webp 890w", "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/3838e/8RoOYk3.webp 1335w", "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/e11e5/8RoOYk3.webp 1780w", "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/26151/8RoOYk3.webp 1804w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/159cb41a1b6d61b5fa6a72688b9ba0bd/e92b6/8RoOYk3.png 223w", "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/e66bf/8RoOYk3.png 445w", "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/4ef49/8RoOYk3.png 890w", "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/4e814/8RoOYk3.png 1335w", "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/701e9/8RoOYk3.png 1780w", "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/f3015/8RoOYk3.png 1804w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/159cb41a1b6d61b5fa6a72688b9ba0bd/4ef49/8RoOYk3.png",
              "alt": "8RoOYk3",
              "title": "8RoOYk3",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`I suck at calendars. Never could make them work for me. Been trying for 10 years.`}</p>
    <p>{`When was the last time you did everything in exactly the same order at exactly the same time as your calendar said? For me the answer is never.`}</p>
    <p>{`That's where Klok comes in. Klok gives you a birds-eye view of `}<strong parentName="p">{`what happened`}</strong>{`. Not what you `}<em parentName="p">{`intended`}</em>{` to happen.`}</p>
    <p>{`I use it to track time on broad projects. How much time working out? How much time sidehustling? How much time writing? How much time at work?`}</p>
    <p>{`Here's a fairly typical week`}</p>
    <p><a parentName="p" {...{
        "href": "http://getklok.com/"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.47085201793722%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'261\\'%20viewBox=\\'0%200%20400%20261\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20131v130h401V0H0v131M235%2024v10l1%209h48V25l-1-2h-24l-24%201M78%2092c0%202%2047%201%2048-1l-24-1c-21%200-24%200-24%202m158%204c-2%203%201%203%2024%203%2022%200%2023%200%2023-2s-1-2-23-2l-24%201m105%2018l1%207h46v-13h-47v6m-211-1v11l1%209h23l24-1v-19c0-2-47-2-48%200m105%202v9l1%208h23l24-1v-16c0-2-47-1-48%200m-51%203l-1%208v7h48v-7l-1-8h-46m104%206l1%207h47v-14h-48v7m-53%2013v28l1%2026h47v-54c0-2-47-2-48%200m-157%202v5l1%204%206-1h41v-8l-24-1-24%201m53%200l-1%2016%201%2015h23l24-1v-30c-2-2-45-2-47%200m53%200l-1%2017v17h48v-17l-1-17h-46m104%205v17l1%2016h47v-33l-24-1-24%201M79%20154c-2%201-1%2014%200%2015v1l-1%202c0%202%201%202%2024%202%2021%200%2023%200%2024-2l-1-2v-2l1-8v-6l-24-1-23%201m-53%2015v8l16%201%2022-1h9v-4c0-3-1-4-2-4H26m104%204v10l1%208h47v-18c0-2-47-1-48%200m53%2011v8h48v-17h-48v9m-104-7l-1%202c0%202%201%202%2024%202s24-1%2024-2a216%20216%200%2000-47-2m0%207l-1%208v7h48v-15l-24-1-23%201m53%2012l-1%2010v4h47v-14l-23-1-23%201m51%201v8l1%207h47v-15l-24-1-24%201m53%201v10h47v-11l-23-1h-23l-1%202M25%20213v5l1%203h23v-8l-12-1-12%201m53%2015v9l1%208h47v-17l-24-1-24%201m-52%207l-1%207%201%206h47v-6c0-5%200-7-2-7H26m105%2010c-2%203%200%203%2023%203s28-1%2023-3h-46\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d143fdae4117e7c891aa0c1e6e40d866/ca0a1/M1nyLdv.webp 223w", "/static/d143fdae4117e7c891aa0c1e6e40d866/75680/M1nyLdv.webp 445w", "/static/d143fdae4117e7c891aa0c1e6e40d866/8d1ba/M1nyLdv.webp 890w", "/static/d143fdae4117e7c891aa0c1e6e40d866/3838e/M1nyLdv.webp 1335w", "/static/d143fdae4117e7c891aa0c1e6e40d866/156b8/M1nyLdv.webp 1564w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d143fdae4117e7c891aa0c1e6e40d866/e92b6/M1nyLdv.png 223w", "/static/d143fdae4117e7c891aa0c1e6e40d866/e66bf/M1nyLdv.png 445w", "/static/d143fdae4117e7c891aa0c1e6e40d866/4ef49/M1nyLdv.png 890w", "/static/d143fdae4117e7c891aa0c1e6e40d866/4e814/M1nyLdv.png 1335w", "/static/d143fdae4117e7c891aa0c1e6e40d866/c8ad9/M1nyLdv.png 1564w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/d143fdae4117e7c891aa0c1e6e40d866/4ef49/M1nyLdv.png",
              "alt": "M1nyLdv",
              "title": "M1nyLdv",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`Pink-ish is sidehustle stuff, green is client work, purple is running, grey-ish is gym time.`}</p>
    <p>{`You can see I've been good about going to bed around midnight, waking up early, and that I took Valentine's Day evening off to hang with The Girl.`}</p>
    <p>{`You even get a high level piechart of how you spend your time.`}</p>
    <p><a parentName="p" {...{
        "href": "http://getklok.com/"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "78.47533632286996%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'314\\'%20viewBox=\\'0%200%20400%20314\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20157v157h401V0H0v157m259-78l-2%201-3%201-2-1v-1l-2%202c1%203%205%204%207%201h2c1-1%201-1%201%201h25c3%200%201-3-2-2l-3-1h-1c-2%201-14%200-17-1h-3m-64%2080c-6%200-150%2026-151%2026-2%202%207%2030%2014%2043%2016%2032%2052%2063%2087%2074a150%20150%200%2000199-134l1-9-73-1-77%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/545f81bc2d5511290709fc75bc0d2709/ca0a1/EB2zw05.webp 223w", "/static/545f81bc2d5511290709fc75bc0d2709/75680/EB2zw05.webp 445w", "/static/545f81bc2d5511290709fc75bc0d2709/8d1ba/EB2zw05.webp 890w", "/static/545f81bc2d5511290709fc75bc0d2709/07cde/EB2zw05.webp 1304w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/545f81bc2d5511290709fc75bc0d2709/e92b6/EB2zw05.png 223w", "/static/545f81bc2d5511290709fc75bc0d2709/e66bf/EB2zw05.png 445w", "/static/545f81bc2d5511290709fc75bc0d2709/4ef49/EB2zw05.png 890w", "/static/545f81bc2d5511290709fc75bc0d2709/71e8d/EB2zw05.png 1304w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/545f81bc2d5511290709fc75bc0d2709/4ef49/EB2zw05.png",
              "alt": "EB2zw05",
              "title": "EB2zw05",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`About half my time goes to paid work, a quarter goes to sidehustle, and a quarter to self improvement. Self improvement tracks high these days because of marathon training and some Ramit Sethi courses I'm doing.`}</p>
    <p>{`Got data going as far back as 2009. Some fun stats:`}</p>
    <ul>
      <li parentName="ul">{`1807 hours on my first startup`}</li>
      <li parentName="ul">{`5073 hours on blog, sidehustle, etc`}</li>
      <li parentName="ul">{`6181 hours on self improvement`}</li>
      <li parentName="ul">{`1971 hours on college`}</li>
      <li parentName="ul">{`10352 hours on paid work`}</li>
    </ul>
    <p>{`So now we know why I never graduated 😅`}</p>
    <h2 {...{
      "id": "billable-hours--toggl"
    }}>{`Billable hours – Toggl`}</h2>
    <p>{`Never bill by the hour. Always know how many hours you're spending.`}</p>
    <p>{`That's how you know if the project fee (or your paycheck) was worth it. Try to account for all time spent, not just butt in seat time.`}</p>
    <p>{`Toggl is great because it's a timer.`}</p>
    <p>{`Click track and it starts tracking. Klok does that too btw but I find Toggl is more fine-grained. I can track overhead and work work separately.`}</p>
    <p><a parentName="p" {...{
        "href": "https://toggl.com"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "74.43946188340806%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'297\\'%20viewBox=\\'0%200%20400%20297\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M129%2088v37h41V51h-41v37m-46%204v33h41l-1-33V59H83v33m93%201v32h41l-1-32V60h-40v33m-139%208l-1%2022c0%202%202%202%2020%202h21V81H37v20m259%2067a64%2064%200%201076%2082c16-48-28-95-76-82m10%2031c-38%207-32%2062%206%2062%2018%201%2031-11%2032-29%201-22-17-38-38-33\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/93f73a1109414b7ddd5e4ee1be6bcc1f/ca0a1/jietonQ.webp 223w", "/static/93f73a1109414b7ddd5e4ee1be6bcc1f/75680/jietonQ.webp 445w", "/static/93f73a1109414b7ddd5e4ee1be6bcc1f/8d1ba/jietonQ.webp 890w", "/static/93f73a1109414b7ddd5e4ee1be6bcc1f/3838e/jietonQ.webp 1335w", "/static/93f73a1109414b7ddd5e4ee1be6bcc1f/dc596/jietonQ.webp 1712w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/93f73a1109414b7ddd5e4ee1be6bcc1f/e92b6/jietonQ.png 223w", "/static/93f73a1109414b7ddd5e4ee1be6bcc1f/e66bf/jietonQ.png 445w", "/static/93f73a1109414b7ddd5e4ee1be6bcc1f/4ef49/jietonQ.png 890w", "/static/93f73a1109414b7ddd5e4ee1be6bcc1f/4e814/jietonQ.png 1335w", "/static/93f73a1109414b7ddd5e4ee1be6bcc1f/56caf/jietonQ.png 1712w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/93f73a1109414b7ddd5e4ee1be6bcc1f/4ef49/jietonQ.png",
              "alt": "jietonQ",
              "title": "jietonQ",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`You get pretty charts. Helps you know how much time you're spending and where. Differences between Klok and Toggl are good area to optimize.`}</p>
    <p>{`Klok says you spent 10 hours at the office and Toggl says you worked 8. Why?`}</p>
    <h2 {...{
      "id": "focus--rescuetime"
    }}>{`Focus – RescueTime`}</h2>
    <p>{`RescueTime runs in the background and keeps watch. Tells you when you're being focused and when you aren't.`}</p>
    <p>{`This level of detail is too fine-grained for manual tracking and that's the point. You tell RescueTime which apps you consider productive and which you don't and it makes pretty graphs based on your activity.`}</p>
    <p><a parentName="p" {...{
        "href": "https://rescuetime.com"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "39.46188340807175%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'158\\'%20viewBox=\\'0%200%20400%20158\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M272%203v8l1%206h10V2h-5l-6%201m112%207v7h11V3l-6-1h-5v8M257%2035c0%203%202%205%203%203h2c1%202%203%201%203-1h2l1%201h11c0%202%204%201%205-1h1l1%201%201-1c-1-2%200-1%202%201l2%201%202-1c2-2%203-3%203-1l1%201c1%201%202%200%202-1%200-3-1-3-10-2a125%20125%200%2000-11%200l-1%201-2-1-2-1h-12c-1-2-4-1-4%201m-52%2011c-2%203%202%203%2095%203%2094%200%2095%200%2095-2s-1-2-95-2l-95%201m51%2013l-3%201-3%201-2-1c-2-2-5-1-4%201l1%201h1l3%201%204-1h1c1%202%2019%202%2020%200l1-1%201%201v1l1-2c-1-2-15-3-15%200l-2%201c-2%200-2%200-1-2v-1h-3m29%200l1%202%202%202c-1%201%206%201%207-1h1c0%201%204%202%205%201h1c1%201%2011%200%2012-1h2l1%202%202%201c1%200%202-1%202-3s-1-2-5-2l-5-1-2%201c-2%202-2%202-2%200-1-2-2-2-3-1h-10l-4%201-2-1v-1l-3%201m-80%2013c0%202%200%202%2074%202%2065%200%2075-1%2075-2s-10-2-75-2c-74%200-74%200-74%202M26%2081v15l1%2014h11V80h-6l-6%201m132%201c-17%205-25%2025-15%2040%204%206%205%207%208%204%202-3%202-3%205-1l6%201c3%200%203%200%203%204s0%204%203%204c12%200%2023-13%2023-26%200-17-17-31-33-26M74%2097v14h12V83H74v14m-32%200l1%2012h11V86H42v11m16%202v12h12V87H58v12m100-7c-8%204-12%2014-8%2022%206%2017%2031%2012%2031-6%200-12-12-20-23-16m46%204c-1%203%203%203%2028%203%2024%200%2027-1%2027-2%200-2-2-2-27-2l-28%201m-194%205v9h12v-4c0-4%200-5-2-5a1788%201788%200%2001-10%200m148%201c-2%201-4%207-2%2010s7%203%208-1l1-2%201%202c0%202%201%203%204%203%205%200%207-6%204-10-3-5-9-2-9%203%200%202%200%202-1%201l-4-2c-3%200-2-2%202-2l2-2h-6M27%20115l-1%2010v10h12v-21h-5l-6%201m15%209v11h12v-20l-6-1h-6v10m16%200v10h6c6%201%206%201%206-11v-8l-6-1h-6v10m16%200v11h12v-20l-6-1h-6v10m131%2022c-2%203%201%203%2021%203s21%200%2021-2-1-2-21-2l-21%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/48a5038fd8b923448d0b407bf159c49e/ca0a1/wXvRVtO.webp 223w", "/static/48a5038fd8b923448d0b407bf159c49e/75680/wXvRVtO.webp 445w", "/static/48a5038fd8b923448d0b407bf159c49e/8d1ba/wXvRVtO.webp 890w", "/static/48a5038fd8b923448d0b407bf159c49e/3838e/wXvRVtO.webp 1335w", "/static/48a5038fd8b923448d0b407bf159c49e/e11e5/wXvRVtO.webp 1780w", "/static/48a5038fd8b923448d0b407bf159c49e/a466f/wXvRVtO.webp 2018w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/48a5038fd8b923448d0b407bf159c49e/e92b6/wXvRVtO.png 223w", "/static/48a5038fd8b923448d0b407bf159c49e/e66bf/wXvRVtO.png 445w", "/static/48a5038fd8b923448d0b407bf159c49e/4ef49/wXvRVtO.png 890w", "/static/48a5038fd8b923448d0b407bf159c49e/4e814/wXvRVtO.png 1335w", "/static/48a5038fd8b923448d0b407bf159c49e/701e9/wXvRVtO.png 1780w", "/static/48a5038fd8b923448d0b407bf159c49e/aea0a/wXvRVtO.png 2018w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/48a5038fd8b923448d0b407bf159c49e/4ef49/wXvRVtO.png",
              "alt": "wXvRVtO",
              "title": "wXvRVtO",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`You can see I've been pretty good this week. Actually spent more time creating than talking about creating.`}</p>
    <p>{`And only 7% social networking! 🤘`}</p>
    <p>{`A great companion for RescueTime is `}<a parentName="p" {...{
        "href": "https://gyrosco.pe/"
      }}>{`Gyrosco.pe`}</a>{`. One of the most beautiful apps I've ever seen built with React and D3.`}</p>
    <p>{`Here's a look at `}<a parentName="p" {...{
        "href": "https://gyrosco.pe/swizec/helix/"
      }}>{`my public dashboard`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://gyrosco.pe/swizec/helix/"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "54.26008968609865%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'218\\'%20viewBox=\\'0%200%20400%20218\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v109h401V0H0v109m84-94l1%202%201%202c0%202%200%202%201%200l2-3v2c0%203%200%203%204%203s6-2%203-4c-1-1-1-1%201-1%201%200%202%201%202%203l1%203v-3c0-4%202-4%202%200%200%202%202%203%205%201h14l2-1%201-3c0-2-3-3-4%200l-1-1h-1l-2%201c-1-2-28-3-29-1h-1l-1-1-1%201m79%2043l-6%203h-36c-31%200-40%201-35%203l1%202%201%202%201-1c-2-5%200-5%2033-5%2032%200%2034%200%2032%205l1%201%201-3c0-2%201-2%2011-2h11l-10-1h-9l6-3c7-3%208-3%2016-2%202%201%202%201%200%200-5-3-11-2-18%201m47%200l-10%201c0%201-10%201-15-1-2%200-2%200-1%201v1c-1%201%206%201%2015%201l13-1%209-1h41c-1-1-34-2-52-1M12%20122v6c0%202%200%202%201%201h3l-2%201c-3%200%200%201%203%202l2-1c-1-2%200-3%201-3l1%202v1l1-2%201-4c0-2%200-2-2-3l-3-2c1-2%204-1%204%201%201%201%201%201%201-1s-1-2-2-2l-3%201h-1l-4-1c-2%200-2%200-1%204m158-1c-2%203-2%203-1%206%202%204%205%205%209%204h3c2%201%209%200%2011-2s3-6%200-9c-2-3-19-3-22%201m-87%2066l51%201a505%20505%200%20000-2l-51%201m106%200l41%201%2041-1-42-1c-27%200-41%200-40%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/a6fff16bafb7228efb92d6468b286043/ca0a1/GqUbjdp.webp 223w", "/static/a6fff16bafb7228efb92d6468b286043/75680/GqUbjdp.webp 445w", "/static/a6fff16bafb7228efb92d6468b286043/8d1ba/GqUbjdp.webp 890w", "/static/a6fff16bafb7228efb92d6468b286043/3838e/GqUbjdp.webp 1335w", "/static/a6fff16bafb7228efb92d6468b286043/e11e5/GqUbjdp.webp 1780w", "/static/a6fff16bafb7228efb92d6468b286043/da98d/GqUbjdp.webp 1922w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/a6fff16bafb7228efb92d6468b286043/e92b6/GqUbjdp.png 223w", "/static/a6fff16bafb7228efb92d6468b286043/e66bf/GqUbjdp.png 445w", "/static/a6fff16bafb7228efb92d6468b286043/4ef49/GqUbjdp.png 890w", "/static/a6fff16bafb7228efb92d6468b286043/4e814/GqUbjdp.png 1335w", "/static/a6fff16bafb7228efb92d6468b286043/701e9/GqUbjdp.png 1780w", "/static/a6fff16bafb7228efb92d6468b286043/c6720/GqUbjdp.png 1922w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/a6fff16bafb7228efb92d6468b286043/4ef49/GqUbjdp.png",
              "alt": "GqUbjdp",
              "title": "GqUbjdp",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`Those intertwined green and red lines, that's how focused I was through the day. Great way to visualize it.`}</p>
    <h2 {...{
      "id": "sidehustle-areas--timeular"
    }}>{`Sidehustle areas – Timeular`}</h2>
    <p>{`Timeular is the newest addition to my flock of time tracking apps. I use it to measure different areas of creativity.`}</p>
    <p>{`Writing, video, livecoding, marketing, stuff like that.`}</p>
    <p>{`It isn't super useful and I don't look at the charts very often, but I like that it comes with a physical device that you twist and turn and plop down to start your timer.`}</p>
    <p><a parentName="p" {...{
        "href": "https://timeular.com/"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.18385650224215%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'533\\'%20viewBox=\\'0%200%20400%20533\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M16%201l-4%201C9%202%208%202%208%204L4%205C1%205%200%205%200%207l4%201%204%201-4%201H0v62h8v16h8v4l-1%204c-2%200-2%201-2%204%200%204%200%204%204%204h4l1%208c0%208%200%208%203%208%202%200%202%200%202%204l1%204%201%208c0%206%200%208%202%208l1-4%201-4%201%204c0%203%200%204%202%204l1%208v8h3c3%200%203%200%203%204%200%203%200%204%202%204l1%204%201%206%201-1%202-1%201%204c0%204%200%204%203%204%202%200%202%200%202%204%200%203%200%204%202%204l1%204%201%204%201%204%201%204%201%204c0%203%200%204%202%204l1%206c0%205-1%207-2%203-1-1-1%200-1%203l-1%204-3%205-3%204-7%205c-9%208-9%208-15%2011l-7%205-3%202-4%202-5%203c-2%200-3%201-3%202l-3%201c-1-1-2%200-2%201%200%202-1%200-2-3l-5-19a163%20163%200%20005%2050c1%206%202%203%201-7%200-5%200-9%201-7s5%2026%206%2040c1%2013%201%2013%206%205l6-10%206-8a359%20359%200%20014-5h1v-2l2-2%202-2v-1h2c-1-2%202-5%203-4l1-1h2l-3%205a198%20198%200%2000-17%2020c-2%200-2%201-2%203%200%203%200%203-1%202%200-2-1-1-4%205l-5%208-1%202c0%203%209%201%2019-4a233%20233%200%200146-19l9-3%206-2%207-2%202-1%202-1%207-2%206-3%203-11%203-15c1-6%202-6%2023-5a464%20464%200%200080%203l4%202-4%201c-15%208-12%2021%205%2021l5%201c-2%201-2%206%201%209l6%203%207%203c7%204%2024%208%2040%2011%2017%203%2042%201%2047-3l4-2c2%200%2015-8%2016-10l1-4%201-2%201-3%201-3c1%200%201-1-1-2l-2-2-2-1-2-2c-3%200-5-3-4-4v-2l-1%201h-1v-2l-3-2-3-2c-4%200-5-1-4-3%202-3%201-4-2-5l-3-1-4-3-3-2%206-4c7-4%2010-5%2011-3h4l-2-1c0-1%203-2%204-1h9l9%202%207%202%209%202h4l-3-2c-1-1-3-2-4-1l-3-1-5-2-3-2-5-2-6-4-4-4%204-4%206-5c2%200%207%204%208%207%202%203%204%204%204%201-1-5%201-3%204%204l10%2014%201-1v-1l1%202v1h1l1-1%201%202%202%202%201%203c0%201-1%201-4-1-4-2-4-2-7-1-4%202-6%205-4%208%200%201%200%202-2%202v3c-2%202-2%202%200%202%202%201%202%201%202%204l-2%206-1%206c-2%204-1%205%205%202l9-2h4v-11a611%20611%200%20000-72v-20l-5%204-6%209c-3%205-4%204-2-2l7-10%206-6v-43l-6-1a12225%2012225%200%2001-124-7V96h-2l-3-1%202-1%201-2%201-2%202-1h-2c-3%200-3%200-3-2s-1-2-5-2c-5%201-7-1-6-3h1l3%201v-2l-4-4c-1-3-2-5-4-6-3-1-3-1-2-2l2-3%204-7%201-1%201-2%202-2c0-2%201-3%202-3%202%200%201-3-1-5a183%20183%200%2000-21-15l-2-2-4-2-1-2%204-1%202-2v-3h-4l-2%204-1%201v-8h-3c1%202%200%203-2%202l-3%201c-2%202-5%201-6-1l-4-2-1-1-2-2c-2%200-3-2-3-2l-1-2c-2%200-5-3-5-4%200-2%202-3%203-2l4%202%201-1V1l-1%201h-1l-1-1-16-1-17%201-1%202c0%202%209%203%2011%201l-4-1h-5l5-1c5%200%205%200%205%203s0%203-4%203l-4%201%203%204%205%206%202%203c0%202%202%201%203-2%200-4%205-4%205%201l1%202%201%207%202%208c3%202%205%2013%203%2012-1%200-2%201-2%204%200%206-2%2010-6%2011-4%200-5%200-1-2l3-4%202-2v-2l-4-1h-4c0-2%200-2%204-2l2-1-1-1-7-4%201-2-1-2v-1c2%200%202-7%200-7l-1-4c0-4%200-5-1-4-2%200-3-2-1-2v-1l-2-2-2-2-1-1c0-2-7-8-8-8h-4c-2-1-3-1-6%201l-4%202v10c1%202%202%203%204%203%204%201%204%202%201%203l-2%204c0%203%201%204%202%202s4%201%204%203l2%201-1%201-2%203v2l-1%202-2%201-2-1c0-3-4-5-5-4-3%201-9%200-9-2v-1l-1-1-1-2v-8c0-3%205-3%206%200%200%202%201%201%203-3%203-7%201-14-4-16-1-1-2-2-1-3l-1-2-1-3c0-2-2-3-3-1h-2c0-1-125-2-125%200m144%2050l-2%203-1%202c1%200%201%201-1%201-1%201-2%202-2%207v7l1%205-1%203c0%202%204%202%2010%200%202-1%202-5-1-5v-4c-1-2-3-13-2-16v-3h-1m178%20175l-9%203%2010%208c8%207%2012%208%2012%205h1l1-1v-1c1%201%207-4%207-6h-1c-2%201-3%200-1-2%201-1-9-9-11-9l-9%203m-18%2035c0%201-16%202-16%200l-8%201-6%202c-6%200-8%201-1%201%204%200%204%200%201%201h-10c-7-1-12-1-15%201l-6%202-3%201%204-1a264%20264%200%200142%200h3l-3-1-2-1h2c5%200%207%201%204%202-2%201-2%201%201%201l3-1h2c0%201%207-2%2012-6l1-2c-1%200-2%200-1-1l-1-1-3%202m-29%2026l-33%2011c-3%200-5%202-4%204%200%202%2013%206%2025%209%208%201%2033%202%2031%200-1-1%200-5%202-9l3-2%206%201c10%202%2011%202%2012%200l-1-2v-1l-2-1v-2h-1l-1-1-2-1c-2%200-2-1-1-1v-1c-1-2-5-3-5-2l-7%202c-8%201-12%200-14-4-2-2-2-2-8%200m-78%2053a589%20589%200%2000-4%2036c2%200%207-6%208-9h2c1%201%201%201%201-1v-3c1%200%202%203%201%208-1%2013%209%2024%2027%2029%2031%208%2060-9%2050-29-3-5-17-21-21-23-6-4-12-5-21-5-10%201-14%203-22%2011-6%206-11%209-6%204%202-2%202-3%201-3l-2%202c-1%202-3%200-3-3h1l1%201%201-1v-2c2-1-2-9-4-8l-2-2c-1-3-2-3-6-3l-1-2-1%203m153%2026a1746%201746%200%2001-12%2048l-4-3a556%20556%200%2001-21-4l-6%201c-8%200-8%201-25%2037a15139%2015139%200%2001-42%2087l72%201h72v-55c0-97%201-86-2-86-5-2-5-2-2-8l4-7-9-4-13-7c-9-4-11-4-12%200M164%20503l5%205%205%206c0%203-4%201-10-5l-7-6-21%202c-20%203-21%203-30%208-10%204-10%205-10%208s0%203-1-1l-1-4v5l-1%206-1%201h1l1%202-1%203h29c28%200%2029%200%2036-3l9-4%204-1c2%200%202%200%201-1-2-2-2-2%200-3h3v1l1-2v-1c3%202%202-12-1-16-1-1-11-2-11%200M33%20527l-18%206h30v-3l1-3H33\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d544076a11932664a34f2a543276ae86/ca0a1/n0TTk6t.webp 223w", "/static/d544076a11932664a34f2a543276ae86/75680/n0TTk6t.webp 445w", "/static/d544076a11932664a34f2a543276ae86/8d1ba/n0TTk6t.webp 890w", "/static/d544076a11932664a34f2a543276ae86/3838e/n0TTk6t.webp 1335w", "/static/d544076a11932664a34f2a543276ae86/e11e5/n0TTk6t.webp 1780w", "/static/d544076a11932664a34f2a543276ae86/e51ec/n0TTk6t.webp 3024w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d544076a11932664a34f2a543276ae86/853b2/n0TTk6t.jpg 223w", "/static/d544076a11932664a34f2a543276ae86/0a4fe/n0TTk6t.jpg 445w", "/static/d544076a11932664a34f2a543276ae86/7f80b/n0TTk6t.jpg 890w", "/static/d544076a11932664a34f2a543276ae86/dc6ba/n0TTk6t.jpg 1335w", "/static/d544076a11932664a34f2a543276ae86/2d2e5/n0TTk6t.jpg 1780w", "/static/d544076a11932664a34f2a543276ae86/9568a/n0TTk6t.jpg 3024w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/d544076a11932664a34f2a543276ae86/7f80b/n0TTk6t.jpg",
              "alt": "n0TTk6t",
              "title": "n0TTk6t",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`I waver between `}<em parentName="p">{`"That has too many sides"`}</em>{` and `}<em parentName="p">{`"Ugh not enough options"`}</em>{`. It's neat though, great idea.`}</p>
    <p>{`If I had one at work I'd use this instead of Toggl :D`}</p>
    <p>{`The charts are ... okay`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/79823143c721f971b513426955e7c2b1/24def/ZJpa7sO.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.98654708520179%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'244\\'%20viewBox=\\'0%200%20400%20244\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M343%2039c-3%203-3%208%200%2010%203%203%2043%203%2046%200s3-6%200-9l-2-3h-21c-20%200-21%200-23%202M82%2055l-16%206c-1%201%202%206%203%206%2021-10%2039-10%2055%200%2030%2017%2035%2059%2011%2083-31%2031-86%2013-91-30%200-6-1-6-3-6-3%200-3%200-3%204a60%2060%200%2000117%2012c2-8%202-27-1-36a60%2060%200%2000-72-39m262%206c-4%203-4%207-1%2010%202%202%203%202%2023%202h21l2-3c2-3%202-7-1-9-4-3-41-3-44%200m0%2044c-4%203-4%208-1%2010%202%202%2042%203%2045%201%203-3%204-8%201-10l-3-3h-20c-18%200-20%200-22%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/79823143c721f971b513426955e7c2b1/ca0a1/ZJpa7sO.webp 223w", "/static/79823143c721f971b513426955e7c2b1/75680/ZJpa7sO.webp 445w", "/static/79823143c721f971b513426955e7c2b1/8d1ba/ZJpa7sO.webp 890w", "/static/79823143c721f971b513426955e7c2b1/3838e/ZJpa7sO.webp 1335w", "/static/79823143c721f971b513426955e7c2b1/e11e5/ZJpa7sO.webp 1780w", "/static/79823143c721f971b513426955e7c2b1/e3ca4/ZJpa7sO.webp 1812w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/79823143c721f971b513426955e7c2b1/e92b6/ZJpa7sO.png 223w", "/static/79823143c721f971b513426955e7c2b1/e66bf/ZJpa7sO.png 445w", "/static/79823143c721f971b513426955e7c2b1/4ef49/ZJpa7sO.png 890w", "/static/79823143c721f971b513426955e7c2b1/4e814/ZJpa7sO.png 1335w", "/static/79823143c721f971b513426955e7c2b1/701e9/ZJpa7sO.png 1780w", "/static/79823143c721f971b513426955e7c2b1/24def/ZJpa7sO.png 1812w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/79823143c721f971b513426955e7c2b1/4ef49/ZJpa7sO.png",
              "alt": "ZJpa7sO",
              "title": "ZJpa7sO",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`🤨`}</p>
    <p>{`And that's how I track my time, do you track your time?`}</p>
    <p>{`Also that was 5 things wasn't it? Five things Friday! 🤘`}</p>
    <p>{`Cheers, ~Swizec`}</p>
    <p>{`PS: honorable mention because it's really cool. Kristian Heruc compiled a list of many hundreds `}<a parentName="p" {...{
        "href": "https://reactresources.com"
      }}>{`React Resources`}</a>{` It's real good. There's even a list of `}<a parentName="p" {...{
        "href": "https://reactresources.com/people/swizec-teller"
      }}>{`some of my React stuff`}</a>{` ❤️`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      